/* eslint-disable no-param-reassign */
export default (state, { payload }) => {
  state.currentAccountId = payload ? Number(payload) : null;
};
